import BaseModel from "./BaseModel";

export default class User extends BaseModel {
    static data_name = 'sessions';

}